export const initialState = {
  property: {
    id: null,
    propertyCode: '',
    propertyName: '',
    propertyTypeId: null,
    propertyTypeCode: '',
    orderNo: null,
    readOnly: false,
    allowAllContext: false,
    allowDefaultRead: false,
    allowDefaultWrite: false,
    categoryId: null,
    decimalPlaces: null,
    changed: false,
    saving: false,
    propertyContexts: [],
    propertyApplications: []
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnPropertyValuesChanged':
      return onPropertyValuesChanged(state, action);
    case 'OnPropertySaved':
      return onPropertySaved(state, action);
    case 'OnPropertySaveStarted':
      return onPropertySaveStarted(state, action);
    case 'OnPropertySaveFailed':
      return onPropertySaveFailed(state, action);
    case 'OnPropertyContextChange':
      return onPropertyContextChange(state, action);
    case 'OnPropertyApplicationsChange':
      return onPropertyApplicationsChange(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  // eslint-disable-next-line no-unused-vars
  const { propertyDetails, propertyUserGroups, ...property } = action.data;
  return {
    ...state,
    property: {
      ...property,
      changed: false,
      saving: false
    }
  };
}

function onPropertyValuesChanged(state, action) {
  const { propertyName, value } = action;
  return {
    ...state,
    property: {
      ...state.property,
      [propertyName]: value,
      propertyContexts:
        propertyName === 'allowAllContext' ? (value === true ? [] : state.property.propertyContexts) : state.property.propertyContexts,
      changed: true
    }
  };
}

function onPropertySaved(state, action) {
  const { id, propertyContexts } = action;
  return {
    ...state,
    property: {
      ...state.property,
      id: id,
      propertyContexts: propertyContexts,
      changed: false,
      saving: false
    }
  };
}

const onPropertySaveStarted = state => {
  return {
    ...state,
    property: {
      ...state.property,
      saving: true
    }
  };
};

const onPropertySaveFailed = state => {
  return {
    ...state,
    property: {
      ...state.property,
      saving: false
    }
  };
};

function onPropertyContextChange(state, action) {
  const contextIds = [...action.event];
  return {
    ...state,
    property: {
      ...state.property,
      propertyContexts: contextIds.map(x => ({ propertyId: state.property.id, contextId: x })),
      changed: true
    }
  };
}

function onPropertyApplicationsChange(state, action) {
  const applications = [...action.event];
  return {
    ...state,
    property: {
      ...state.property,
      propertyApplications: applications.map(x => ({ appCode: x.appCode })),
      changed: true
    }
  };
}
